// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".academy-guides-overlay{z-index:499}.academy-guides-search-modal-ui{z-index:500!important}.academy-guides-search-modal-ui .search_input{outline:none}.ui-modal.academy-guides-search-modal-ui{bottom:0;left:0;position:fixed;right:0;top:0;z-index:500}@media (min-width:768px){.ui-modal.academy-guides-search-modal-ui{border-radius:16px;bottom:auto;height:640px;left:auto;left:50%;overflow:hidden;right:auto;top:auto;top:50%;transform:translate(-50%,-50%);width:680px}}.tab--active{margin-bottom:-2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
